import React from 'react';
import SEOHelmet from '../components/SEOHelmet';

function AboutUs() {
  return (
    <div>
      <SEOHelmet 
        title="About Code It Up 6.0 - Premier Hackathon Event"
        description="Learn about Code It Up - a 24-hour coding hackathon bringing together students, developers, and innovators to build real software solutions, solve programming challenges, and sharpen practical coding skills."
        keywords="code it up, hackathon, about, 24-hour coding, student developers, programming challenge, IEEE hackathon, innovation"
        canonical="https://code-it-up-6.netlify.app/about"
      />
      <h1 style={{ textAlign: 'center' }}>ABOUT US</h1>
      <div className="board">
        <h2 style={{ textAlign: 'center' }}>What Is Code It Up?</h2>
        <p>
          Code It Up is a 24-hour coding hackathon where participants team up to build real software solutions from scratch under time pressure. It’s designed to bring together students and developers to solve real programming challenges, sharpen practical coding skills, and unleash creativity through technology.
        </p>
      </div>
    </div>
  );
}

export default AboutUs;
